import { render, staticRenderFns } from "./SlashedDolar.vue?vue&type=template&id=20578bb1"
import script from "./SlashedDolar.vue?vue&type=script&lang=js"
export * from "./SlashedDolar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports